import { MediaLibFoldersSkeleton } from "@editor/modules/media-lib";

export const MediaLibPanelFoldersSkeleton = () => {
  return (
    <>
      {Array.from({ length: 4 }, (_, idx) => (
        <li key={idx}>
          <MediaLibFoldersSkeleton />
        </li>
      ))}
    </>
  );
};
